// 自定义指令

export default {
  install(application) {
    application.directive('price', {
      mounted(elem) {
        const el = elem;
        el.onkeypress = (event) => {
          const c = String.fromCharCode(event.keyCode || event.which);
          const v = event.target.value;
          // 仅能输入数字和小数点
          if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'].includes(c)) {
            return false;
          }
          if (c === '.') {
            // 如果第一个字符是. 不允许输入
            if (v.trim().length === 0) {
              return false;
            }
            // 如果已经有输入小数点 不允许输入两个
            if (v.includes('.')) {
              return false;
            }
          }
          // 如果第一个是0，第二个必须是小数点
          if (v === '0' && c !== '.') {
            return false;
          }

          // 限制输入2位小数
          if (v.includes('.') && v.split('.')[1].length === 2) {
            return false;
          }
          if (Number(v + c) > 99999) {
            return false;
          }
          return true;
          // const ret = v + c;
          // if (Number.isNaN(Number(ret)) || !/^\d{1,5}(\.\d{1,2})?$/.test(ret)) {
          //   return false;
          // }
          // return true;
        };
        // el.onkeyup = (e) => {
        //   e.target.value = e.target.value.replace(/[\u4e00-\u9fa5]/gi, '');
        // };
        // el.children[0].onblur = (e) => {
        //   const val = e.target.value;
        //   if (val.length > 0 && Number(val) === 0) {
        //     e.target.value = '0';
        //   }
        // };
      },
    });
  },
};
